import LoadingInLine from './LoadingInLine'

export default LoadingInLine
